// Mock data for LAMKO website

export const companyInfo = {
  name: "LAMKO",
  tagline: "Your Trusted Strategic Partner in High-Purity Material Innovation",
  description: "We want to be a global tech and R&D-led supplier-of-choice for speciality chemicals across industries",
  location: "Seoul, South Korea",
  email: "info@lamko.co.kr",
  phone: "+82-10-7269-6809",
  address: "3F, 122, Mapo-daero, Mapo-gu, Seoul, Republic of Korea 04213",
  addressKorean: "서울특별시 마포구 마포대로 122, 3층 04213"
};

export const heroContent = {
  title: "Scale your innovation capacity instantly",
  subtitle: "High-Performance Materials for Semiconductor, Display & Specialty Chemical Industries",
  description: "Leverage our expertise to compress timelines and outpace the competition. We manage the entire development lifecycle - custom synthesis, sample delivery, electronics-grade purification and analytics performed in-house, with production scaled through our audited global manufacturing network. One accountable partner from first gram to production volume.",
  cta: "Discover Our Technology",
  image: "/img/ext/5a71a8138c.jpg"
};

export const aboutContent = {
  whoWeAre: {
    title: "Who We Are",
    content: "LAMKO is a specialty materials company headquartered in Seoul, developing and commercialising high-performance materials for the semiconductor, display and specialty chemical industries. We perform the high-value chemistry in-house - custom synthesis, electronics-grade purification and analytics - and deliver production volumes through a network of audited manufacturing partners, each qualified against our 38-point audit. Every lot ships under LAMKO's quality system with full documentation and single-point accountability."
  },
  coreFunction: {
    title: "Our Core Function",
    subtitle: "The Innovation Gateway: Your R&D Platform for Breakthrough Chemistry",
    description: "We are the strategic R&D Platform with purification units that seamlessly connect cutting-edge Korean research with global market demand and world-class manufacturing capabilities. Our unique CRDMO model focuses precisely on the high-value front end of the innovation chain, accelerating your journey from concept to commercialization."
  },
  goal: {
    title: "Our Goal",
    content: "To de-risk the innovation to production journey, providing our manufacturing partners with a seamless, pre-validated pipeline of advanced projects, ready for scale."
  },
  clients: ["Leading Korean Tech Firms", "Global Material Innovators", "Research Institutions"]
};

export const services = [
  {
    id: 1,
    title: "Specialty Materials Production",
    subtitle: "CMO - Contract Manufacturing Organization",
    description: "Precision Manufacturing, Disruptive Value. Leveraging state-of-the-art technology and audited partner facilities to deliver high-purity specialty materials. We drive down costs through innovation, ensuring you get scalable, consistent quality from pilot to commercial production.",
    image: "/production-goggles.jpg",
    benefits: [
      "High-purity materials manufacturing at scale",
      "Consistent quality and batch-to-batch reliability",
      "Contamination-controlled packaging standards",
      "quality-audited production"
    ],
    forWhom: "Companies needing reliable, scalable manufacturing of specialty materials with stringent purity requirements"
  },
  {
    id: 2,
    title: "Integrated Materials Solutions",
    subtitle: "CRDMO - Contract Research, Development & Manufacturing Organization",
    description: "End-to-end partnership from initial material development through scalable manufacturing and reliable supply chain delivery.",
    image: "/img/ext/a552ad4bc0.jpg",
    benefits: [
      "Complete R&D to manufacturing integration",
      "Seamless technology transfer and scale-up",
      "Reliable supply chain delivery",
      "Single partner for entire value chain"
    ],
    forWhom: "Companies seeking complete materials solution from concept to commercial delivery with reduced risk and faster time-to-market"
  }
];

export const industries = [
  {
    id: 1,
    name: "Semiconductor Materials",
    description: "At LAMKO, we synthesize high-purity specialty monomers, ionomers, and oligomers for advanced photoresist applications. Our custom-developed materials are engineered to meet the exacting demands of modern semiconductor lithography across g/i-line, KrF, ArF, and EUV processes.",
    image: "/img/ext/8b0b5e1979.jpg",
    applications: [
      "Photoresists and specialty chemicals",
      "High-purity process materials",
      "Advanced packaging materials",
      "Etch and deposition chemistries"
    ],
    outcomes: "Faster time-to-market, reduced production risk, electronics-grade purity"
  },
  {
    id: 2,
    name: "Display",
    description: "At LAMKO, we provide end-to-end CRDMO services for building blocks, intermediates, HOST, ETL, and custom stack materials for cutting-edge OLED and next-generation display technologies.",
    image: "/img/ext/c7778ea263.jpg",
    applications: [
      "OLED materials and intermediates",
      "HOST, HTL, HIL, ETL layers",
      "Custom stack materials",
      "Sublimed-grade emitters"
    ],
    outcomes: "Enhanced display performance, cost-optimized production, innovation acceleration"
  },
  {
    id: 3,
    name: "Personal Care Actives",
    description: "At LAMKO, we deliver premium, sustainably produced active ingredients for cosmetic and personal care applications through our end-to-end CRDMO/CDMO services.",
    image: "/img/ext/9c946f8f2c.jpg",
    applications: [
      "Antioxidants and UV filters",
      "Naturally derived emollients",
      "Antifungal compounds",
      "Sustainable actives"
    ],
    outcomes: "High efficacy, proven safety, reduced ecological footprint"
  }
];

export const brands = [
  {
    id: 1,
    name: "LUMORA",
    tagline: "Advanced Materials Korea",
    description: "LUMORA, an exclusive brand of Lumora Advanced Materials Korea, is dedicated to providing innovative solutions for the semiconductor and organic optoelectronic materials industries. Specializing in custom synthesis, LUMORA offers tailored services to develop high-performance materials for advanced applications, including OLED intermediates, OLED reference compounds, and OLED finished products such as HOST, HTL, HIL, ETL, EIL, and Emitters in sublimed grades, designed for scalability from grams to kilograms. With a commitment to quality and innovation, the brand employs state-of-the-art analytical methods to ensure its materials meet the highest industry standards. Operating from its headquarters in Seoul, South Korea, LUMORA provides reliable just-in-time delivery all over the world, ensuring seamless support for its global clientele. By offering a comprehensive range of cutting-edge materials and equipment, LUMORA aims to deliver a total solution for the semiconductor industry, empowering its clients and driving advancements in technology.",
    brandingImage: "/img/ext/1101643d83.png",
    website: "https://lumorachemicals.com/",
    industries: ["Semiconductors", "OLED Materials", "Optoelectronic Materials"]
  }
];

export const reactionCapabilities = {
  title: "Reaction Capabilities",
  description: "Over the years LAMKO has gained widespread experience with challenging reactions for the preparation of advance laboratory samples. In addition to general reactions, we are specialized in following reactions:",
  reactions: [
    { name: "Boylation", category: "General" },
    { name: "Claisen Condensation", category: "General" },
    { name: "Beckmann Rearrangement", category: "Rearrangement" },
    { name: "Halogenations", category: "Halogen" },
    { name: "Bouveault - Blanc Reaction", category: "Reduction" },
    { name: "Catalytic reduction", category: "Reduction" },
    { name: "Nitration", category: "Nitro" },
    { name: "Gabriel Synthesis", category: "Synthesis" },
    { name: "Condensations", category: "General" },
    { name: "Sandmeyer Reaction", category: "Substitution" },
    { name: "Japp - Klingemann Hydrazone Synthesis", category: "Synthesis" },
    { name: "Cyclization", category: "Ring Formation" },
    { name: "Wolff Kishner Reduction", category: "Reduction" },
    { name: "Decarboxylation", category: "Elimination" },
    { name: "Friedel-Craft Reaction", category: "Alkylation" },
    { name: "Bromination", category: "Halogen" },
    { name: "Wittig Reaction", category: "Olefination" },
    { name: "Cyanation", category: "Functional Group" },
    { name: "Oxidation", category: "Redox" },
    { name: "Addition Reaction", category: "Addition" },
    { name: "Diazotisation", category: "Diazo" },
    { name: "Vilsmeier-Haack reaction", category: "Formylation" },
    { name: "Aldol Condensations", category: "C-C Bond" },
    { name: "Coupling Reactions", category: "C-C Bond" },
    { name: "Michael Additions", category: "Addition" },
    { name: "Acetal Formation", category: "Protection" },
    { name: "Epoxidation", category: "Oxidation" },
    { name: "Carboxylation", category: "Functional Group" },
    { name: "Alkylation Amination", category: "Alkylation" },
    { name: "Grignard Reaction", category: "Organometallic" },
    { name: "Dehalogenations", category: "Elimination" },
    { name: "Deprotection", category: "Protection" },
    { name: "Esterification", category: "Functional Group" },
    { name: "Formylation", category: "Functional Group" },
    { name: "Hydrogenation", category: "Reduction" },
    { name: "Hydrolysis", category: "Cleavage" },
    { name: "Mannich Reactions", category: "C-C Bond" },
    { name: "Negishi Coupling", category: "C-C Bond" },
    { name: "Protection", category: "Protection" },
    { name: "Thionation", category: "Sulfur" },
    { name: "Acylation", category: "Functional Group" },
    { name: "De-alkylation cleavage", category: "Cleavage" },
    { name: "Schiff base reaction", category: "Condensation" },
    { name: "Pinner synthesis", category: "Synthesis" }
  ]
};

export const facilityInfrastructure = {
  title: "Facility & Infrastructure",
  description: "LAMKO is a premier, technology-driven bridge between cutting-edge innovation and world-class manufacturing. Strategically headquartered in Seoul with advanced R&D and process intensification facilities, we specialize in the development and commercialization of high-performance materials for the semiconductor, display, and specialty chemical industries.",
  locations: [
    {
      name: "Seoul, Korea - R&D Center",
      description: "Well-equipped Seoul laboratory with sublimation and HPLC for purification and analysis/characterization. Our laboratories are equipped to handle everything from rapid gram-scale screening to multi-kilogram pilot-scale validation, ensuring process safety and scalability.",
      capabilities: [
        {
          category: "Process Development",
          equipment: [
            "Modern Fume Hood Systems",
            "Rotavapor Systems"
          ]
        },
        {
          category: "Analytical Characterization",
          equipment: [
            "HPLC/UPLC Systems",
            "GC/GC-MS Systems",
            "LC-MS Systems",
          ]
        },
        {
          category: "Specialty Materials Processing",
          equipment: [
            "High-Vacuum Sublimation Purification Systems",
            "Inert Atmosphere Glove Boxes",
            "Photoluminescence/Electroluminescence Measurement Systems",
            "Thin-Film Deposition Tools (Spin Coaters, Thermal Evaporators)"
          ]
        }
      ]
    },
    {
      name: "Global Manufacturing Partner Network",
      description: "Quality-audited manufacturing across our growing global partner network - giving you scalable capacity without the overhead of owned plants. Current partner facilities are licensed under the Indian Factory Act.",
      capabilities: [
        {
          category: "Production Infrastructure",
          equipment: [
            "quality-audited partner production space",
            "Process Development Laboratories",
            "Partner facilities operating under applicable manufacturing licences",
            "Scalable Manufacturing Units",
            "Quality Control Facilities"
          ]
        }
      ]
    }
  ],
  endToEnd: "End-to-end development from concept to production-ready processes, delivering optimized, high-purity materials for advanced technology applications."
};

export const contactForm = {
  title: "Let's Discuss Your Project",
  subtitle: "Share a brief summary of your R&D or scale-up challenge",
  fields: [
    { name: "name", label: "Name", type: "text", required: true },
    { name: "company", label: "Company", type: "text", required: true },
    { name: "email", label: "Email", type: "email", required: true },
    { name: "phone", label: "Phone", type: "tel", required: false },
    { name: "project", label: "Project Description", type: "textarea", required: true }
  ]
};

export const stats = [
  { label: "Years of Industry Expertise", value: "15+" },
  { label: "Quality System SOPs", value: "200+" },
  { label: "Industries Served", value: "4" },
  { label: "Custom Synthesis Programs", value: "50+" }
];
